import { useState } from "react"
import PropTypes from "prop-types"
import FilterButton from "./FilterButton"
import FilterBadgeContent from "./FilterBadgeContent"
import { Select } from "components/ui"
import { isBlank } from "utils/helpers"

export const STATUS_KIND = "registrationStatus"

export const statusBadge = (selected, _options) => {
  return <FilterBadgeContent label="Status" value={selected.value} />
}

const StatusOptions = ({ onSubmit }) => {
  const [value, setValue] = useState("")

  const handleSubmit = () => {
    onSubmit({
      value,
      label: statusBadge({ value }),
      kind: STATUS_KIND
    })

    setValue("")
  }

  return (
    <>
      <Select
        name="status"
        id="registrationStatus"
        value={value}
        onChange={e => setValue(e.target.value)}
        options={[
          { value: "", label: "Select a status" },
          { value: "complete", label: "Complete" },
          { value: "incomplete", label: "Incomplete" }
        ]}
      />
      <FilterButton disabled={isBlank(value)} onSubmit={handleSubmit} />
    </>
  )
}

StatusOptions.propTypes = {
  onSubmit: PropTypes.func
}

export default StatusOptions
